import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import MotivosGrid from './MotivosGrid.jsx'
import MotivosAbm from './MotivosAbm.jsx'
import {FormattedMessage, injectIntl} from 'react-intl';

class Motivos extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
	  					<h3 className="content-header-title"><FormattedMessage id="Administración_de_motivos" defaultMessage="Administración de motivos"/></h3>
	  				</div>
				</div>
				<div className="content-body">								
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={MotivosGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <MotivosAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <MotivosAbm {...props} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <MotivosAbm {...props} action="VIEW" />} />
					</Switch>										
				</div>
			</div>
		);
  	}
}

export default Motivos;